import { React, useEffect } from "react";
import AOS from "aos";
import passionImg from "../../Assets/passionImg.png";
import integrityImg from "../../Assets/integrityImg.png";
import empathyImg from "../../Assets/empathyImg.png";
import growthMindsetImg from "../../Assets/growthImg.png";
import technicalDepthImg from "../../Assets/technicalImg.png";
import excellenceImg from "../../Assets/excellenceImg.png";

const CoreBusinessValues = () => {
  useEffect(() => {
    AOS.init({ duration: 1500, behaviour: "smooth" });
  }, []);

  const coreValues = [
    {
      id: 1,
      title: "Automation",
      content:
        "We derive our energy from our singular goal of creating one technology for all logistics businesses",
      img: passionImg,
    },
    {
      id: 2,
      title: "Hosting",
      content:
        "Our dealings with people are based on the pillars of honesty, transparency and fairnesss",
      img: integrityImg,
    },
    {
      id: 3,
      title: "Maintenance",
      content:
        "To understand how people feel and to determine how best to help them, we put ourselves in their shoes",
      img: empathyImg,
    },
    {
      id: 4,
      title: "Media Marketing",
      content:
        "We thrive on challenges, and failure do not define us but rather a springboard for growth and development",
      img: growthMindsetImg,
    },
    {
      id: 5,
      title: `Rider's Application`,
      content:
        "Our business model is based on high tech innovation and digital transformation",
      img: technicalDepthImg,
    },
    {
      id: 6,
      title: `User Application`,
      content:
        "We pride ourselves in being outstanding or extremely good at what we do",
      img: excellenceImg,
    },
  ];
  return (
    <>
      <div className="container-fulid" style={{ background: "#178852" }}>
        <div className="text-center fw-bold fs-2 my-5 text-white pt-5">
          Our Core Values
        </div>

        <div
          className="row text-center px-2 px-md-4 mx-auto"
          style={{ maxWidth: 1152 }}
        >
          {coreValues.map((data) => {
            return (
              <div
                className="col-12 col-md-6 col-lg-4 mb-5"
                key={data.id}
                data-aos="fade-left"
              >
                <div
                  className="bg-white px-3 px-md-4 py-2 py-md-3 rounded"
                  style={{ maxHeight: 225, height: "100%" }}
                >
                  <img src={data.img} alt={data.title + "img"} />
                  <div className="my-2 fw-bold">{data.title}</div>
                  <div>{data.content}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default CoreBusinessValues;
